exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#page-services .user-list-filters .vs__actions {\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-58%);\n}[dir] #page-services .user-list-filters .vs__actions {\n          transform: translateY(-58%);\n}[dir=ltr] #page-services .user-list-filters .vs__actions {\n  right: 0;\n}[dir=rtl] #page-services .user-list-filters .vs__actions {\n  left: 0;\n}\n.popup80 .vs-popup {\n  width: 80% !important;\n}\n.vue_select_drop_size_150 .vs__dropdown-menu {\n  max-height: 150px;\n}\n.vue_select_drop_size_98 .vs__dropdown-menu {\n  max-height: 98px;\n}", ""]);

// exports
